import { createRoot } from 'react-dom/client';
import KangoHeaderNav from '../_src/components/KangoHeaderNav';
import KangoFooterContents from '../_src/components/KangoFooterContents';


const kangoNav = document.querySelector('#js-kangoMainNav');

if (kangoNav) {
  createRoot(kangoNav).render(<KangoHeaderNav />);
}

const footer = document.querySelector('#js-footer');

if(footer) {
  createRoot(document.querySelector('#js-footer')).render(<KangoFooterContents />);
}

// 変数定義

let oldLabel;
let newLabel;

// スムーススクロール リンク

window.addEventListener('load', function () {
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      const screenSize = window.innerWidth;
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = document.getElementById(href.replace('#', ''));
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.scrollY;
      let gap;
      if (screenSize >= 1080) {
        gap = 120;
      } else {
        gap = 80;
      }
      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  }
});

//pageTop

const pagetop = () => {
  window.addEventListener('load', function () {
    const pagetopButton = document.querySelector('.pagetop');

    if (pagetopButton) {
      pagetopButton.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }
  });
};

pagetop();

// スクロール時の挙動

window.addEventListener('load', function () {
  const pagetopItem = document.querySelector('.pagetopWrap');

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const body = document.body;
    body.dataset.scroll = y > 300 ? 'true' : 'false';

    const scrollCount = document.documentElement.scrollTop || document.body.scrollTop;

    const docHeight = document.body.clientHeight;
    const scrollPos = document.documentElement.clientHeight + scrollCount;
    const footer = document.querySelector<HTMLElement>('.footer');
    const pagetopItem = document.querySelector('.pagetopWrap');
    
    if (footer && pagetopItem) {
      window.addEventListener('scroll', () => {
        const scrollCount =
        document.documentElement.scrollTop || document.body.scrollTop;
        
        const docHeight = document.body.clientHeight;
        const scrollPos = document.documentElement.clientHeight + scrollCount;
        
        if (docHeight - scrollPos <= footer.clientHeight - 30) {
          pagetopItem.classList.add('scrolled');
        } else {
          pagetopItem.classList.remove('scrolled');
        }
      });
    }
  });
});

// 通常 アコーディオン制御

const accordiontrigger = document.querySelectorAll('.js-accordionTrigger');
const accordion = document.querySelectorAll('.js-accordion');

accordiontrigger.forEach((item) => {
  item.addEventListener('click', (e) => {
    if (e.currentTarget.getAttribute('aria-expanded') === 'true') {
      oldLabel = e.currentTarget.getAttribute('aria-label');
      if (oldLabel.indexOf('を閉じます')) {
        newLabel = oldLabel.replace('を閉じます', 'を開きます');
        e.currentTarget.setAttribute('aria-label', newLabel);
        e.currentTarget.setAttribute('aria-expanded', 'false');
        e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'true');
      }
    } else {
      oldLabel = e.currentTarget.getAttribute('aria-label');
      if (oldLabel.indexOf('を開きます')) {
        newLabel = oldLabel.replace('を開きます', 'を閉じます');
      } else {
        newLabel = oldLabel.replace('を閉じます', 'を開きます');
      }
      e.currentTarget.setAttribute('aria-label', newLabel);
      e.currentTarget.setAttribute('aria-expanded', 'true');
      e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'false');
    }
  });
});

// タブ切り替え

const filterButtons = document.querySelectorAll('[data-filter]');
const categoryContents = document.querySelectorAll('[data-category]');

filterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', buttonSwitch);
  filterButton.addEventListener('click', categoryFilter);
});

function buttonSwitch() {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove("-active");
    this.classList.add('-active');
  });
}

function categoryFilter() {
  const buttonCategory = this.dataset.filter;
  const targetContents = document.querySelectorAll('[data-category="' + buttonCategory + '"]');

  categoryContents.forEach((categoryContent) => {
    if (buttonCategory == 'all') {
      categoryContent.classList.add('-active');
    } else {
      categoryContent.classList.remove("-active");
      targetContents.forEach((targetContent) => {
        targetContent.classList.add('-active');
      });
    }
  });
}

// バナーを非表示

const closeBannerTrigger = document.querySelectorAll('.js-closeBannerTrigger');
const closeBanner = document.querySelector('.js-closeBanner');

closeBannerTrigger.forEach((item) => {
  item.addEventListener('click', (e) => {
    closeBanner.classList.add('-hidden');
  });
});

// サイドバーメニュー スクロール（リサイズ対応含む）

const stickyContents = document.querySelector<HTMLElement>('.c-stickyContents');

if (stickyContents) {
  const stickyContentsHeight = stickyContents.scrollHeight;

  const stickyContentsHeightChange = () => {
    let timeoutID = 0;
    const delay = 500;

    const setHeight = () => {
      if (window.innerWidth > 960) {
        stickyContents.style.height = `${window.innerHeight - 180}px`;
      } else {
        stickyContents.style.height = 'inherit';
      }
    };

    setHeight();

    window.addEventListener('resize', () => {
      clearTimeout(timeoutID);
      timeoutID = window.setTimeout(setHeight, delay);
    });
  };

  stickyContentsHeightChange();
}

const header = document.querySelector('.header');

window.addEventListener('scroll', () => {
  if (window.scrollY >= 800) {
    header.classList.add('is-scroll');
  } else {
    header.classList.remove('is-scroll');
  }
});